export const BRACKET_IMAGES = {
  websitePrimary: "/images/staketek-star-picket-bracket-front-white-bg.jpg",
  websiteAngle: "/images/staketek-star-picket-bracket-angle-white-bg.jpg",
  // The supported bracket's hero shot, doubling as the merchant photo so the
  // Product schema and the Google feed show buyers the same image the product
  // page leads with. Its ST monogram was removed on 2026-09-09 for exactly this
  // reason: Merchant Center rejects images carrying an overlay, so anything used
  // as a merchant photo has to stay clean.
  merchantPrimary: "/images/staketek-supported-bracket-studio-gal-angled.jpg",
  merchantAngle: "/images/staketek-star-picket-bracket-angle-merchant-white-bg.jpg",
  installedPrimary: "/images/real-bracket-install-3.jpg",
  installedDetail: "/images/real-bracket-detail-1.jpg",
};

export const BRACKET_IMAGE_ALTS = {
  websitePrimary: "Heavy-duty galvanised StakeTek star picket bracket on white background",
  websiteAngle: "StakeTek bracket showing fixing plate and star picket sleeve",
  merchantPrimary: "Heavy-duty galvanised star picket bracket product photo on white background",
  merchantAngle: "Galvanised star picket bracket side view on white background",
  installedPrimary: "StakeTek bracket frame build using timber and star pickets",
  installedDetail: "Close-up of a StakeTek galvanised bracket fixed to timber",
};

// Real flat-bracket photos: the galvanised flat bracket clamping timber boxing
// to a star picket. Genuine job-site shots, not renders.
// Clean white-background studio shots (supplied 2026-07-14). Save the three
// photos to these exact paths in frontend/public/images/ and they appear here.
export const FLAT_BRACKET_IMAGES = {
  primary: "/images/staketek-flat-bracket-white-1.jpg",
  detail: "/images/staketek-flat-bracket-white-3.jpg",
  levelling: "/images/staketek-flat-bracket-white-2.jpg",
  // Kept for the "in use" context shots lower on the page.
  install: "/images/bracket-build-04.jpg",
};
export const FLAT_BRACKET_IMAGE_ALTS = {
  primary: "StakeTek Flat Slide-On Bracket — front view showing the star picket Y-profile sleeve and bolt holes",
  detail: "Top-down view of the StakeTek Flat Slide-On Bracket showing the cross-shaped body and mounting holes",
  levelling: "Angled view of the StakeTek Flat Slide-On Bracket showing the galvanised finish and weld seams",
  install: "StakeTek flat bracket clamping a timber boxing frame to a star picket",
};
